"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMailAddressList = parseMailAddressList;
function parseMailAddressList(raw) {
    const addresses = [];
    for (const entry of raw.split(/[,\n;]/u)) {
        const trimmed = entry.trim();
        if (!trimmed)
            continue;
        const angleMatch = trimmed.match(/<([^<>]+)>$/u);
        const address = (angleMatch?.[1] ?? trimmed).trim();
        if (address.length > 254 ||
            /[\s<>]/u.test(address) ||
            !/^[^@\s]+@(?:[a-z0-9-]+\.)+[a-z]{2,63}$/iu.test(address)) {
            return { addresses: [], valid: false };
        }
        addresses.push(address);
    }
    return { addresses, valid: true };
}
